import { useEffect, useState, RefObject } from 'react';

interface Dimensions {
  borderBox: DOMRectReadOnly;
  contentBox: DOMRectReadOnly;
}

/**
 * Hook customizado para medir dimensões de elementos
 * Substitui o antigo useDimensions do Chakra UI v1
 */
export function useDimensions(
  ref: RefObject<HTMLElement>,
  observe = false
): Dimensions | null {
  const [dimensions, setDimensions] = useState<Dimensions | null>(null);

  useEffect(() => {
    if (!ref.current || !observe) return;

    const resizeObserver = new ResizeObserver((entries) => {
      if (!Array.isArray(entries) || !entries.length) return;

      const entry = entries[0];
      
      setDimensions({
        borderBox: entry.borderBoxSize?.[0] 
          ? new DOMRectReadOnly(
              0,
              0,
              entry.borderBoxSize[0].inlineSize,
              entry.borderBoxSize[0].blockSize
            )
          : entry.target.getBoundingClientRect(),
        contentBox: entry.contentBoxSize?.[0]
          ? new DOMRectReadOnly(
              0,
              0,
              entry.contentBoxSize[0].inlineSize,
              entry.contentBoxSize[0].blockSize
            )
          : entry.target.getBoundingClientRect(),
      });
    });

    resizeObserver.observe(ref.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [ref, observe]);

  return dimensions;
}

